import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { ResponseError } from "./interfaces/api-error";
import {
  GetUserConsumerProfileRequest,
  UserConsumerProfileResponse
} from "./interfaces/get-user-consumer-profile";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";

export async function getUserConsumerProfile(
  data: GetUserConsumerProfileRequest,
  env: Environment
): Promise<UserConsumerProfileResponse> {
  const url = `${getBaseUrl(env)}cxm/user-consumer-profile?consumerId=${
    data.consumerId
  }&consumerRecordSystem=${data.customerSystem}`;

  const header = await getHeader();

  const response = await fetchWrapper.getAsync(url, header);
  if (response && response.data && !response.hasError) {
    return response.data as UserConsumerProfileResponse;
  } else {
    const errorBody = response.data as { message?: string } | null;
    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error,
      message: errorBody?.message
    };
    throw error;
  }
}
